import { ROOT_NODE_ID } from '../../store/migrations/data-structure-conversion'

export const getLabelForNode = (node) => {
    if (!node || node.id === ROOT_NODE_ID) {
        return 'Treelist'
    } else {
        return node.text
    }
}
